<template>
  <div class="Bgc-white">
    <Header />
    <div class="contentContacto">
      <div class="container contacto">
        <div class="row">
          <div class="col-12 mb-0">
            <p class="title mb-4">{{$t('language.posadasCorporate.aclaracionReservaciones.aclaracionReservaciones')}}</p>
            <p class="link f-w-500 mb-2">
              <i class="demo-icon icon-travel"></i>{{$t('language.posadasCorporate.aclaracionReservaciones.datosGenerales')}}
            </p>
          </div>
          <div class="col-12 col-md-3">
            <div class="form-element">
              <label>{{$t('language.posadasCorporate.aclaracionReservaciones.clienteID')}}*</label>
              <div class="Pos-r">
                <input type="text" class="form-control mayuscula"
                  v-model="cliente" maxlength="50"/>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div class="form-element">
              <label>{{$t('language.posadasCorporate.aclaracionReservaciones.nombreUsuario')}}*</label>
              <div class="Pos-r">
                <input type="text" class="form-control minuscula"
                  v-model="usuario" maxlength="50"/>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div class="form-element">
              <label>{{$t('language.posadasCorporate.aclaracionReservaciones.correoElectronico')}}*</label>
              <div class="Pos-r">
                <input type="email" :placeholder="$t('language.posadasCorporate.aclaracionReservaciones.ejemplo') + '@' + $t('language.posadasCorporate.aclaracionReservaciones.correo') + '.com'" class="form-control"
                  maxlength="50"
                  v-model="correo"
                  :class="{ 'is-invalid': (!$v.correo.email)}"/>

                <span class="notas" v-if="!$v.correo.email">{{$t('language.posadasCorporate.reservacionesRegistro.invalidEmail')}}</span>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div class="form-element">
              <label>{{$t('language.posadasCorporate.aclaracionReservaciones.claveConfirmacion')}}*</label>
              <div class="Pos-r">
                <input type="number" :placeholder="$t('language.posadasCorporate.aclaracionReservaciones.caracteres10')" class="form-control"
                    :value="clave" @input="updateValue" onkeypress="return event.key === 'Enter' || (Number(event.key) >= 0 && Number(event.key) <= 9)"/>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-8">
            <div class="form-element">
              <label>{{$t('language.posadasCorporate.aclaracionReservaciones.comentariosAdicionales')}}</label>
              <div class="Pos-r">
                <textarea v-model="adicionales" maxlength="255"></textarea>
                <label for="" class="notas">{{$t('language.posadasCorporate.generals.max255Caracteres')}}</label><br><br>
                <small>* {{$t('language.posadasCorporate.aclaracionReservaciones.camposRequeridos')}}</small>
              </div>
            </div>
          </div>
          <div class="col-12 mt-2 mb-5">
            <Loader v-if="banLoader"/>
            <div class="row">
              <div class="col-4 "></div>
              <div class="col-12 col-md-4">
                <router-link to="/informacion-corporate" tag="button" class="mt-3 secondary-button">
                  {{$t('language.posadasCorporate.aclaracionReservaciones.regresar')}}
                </router-link>
              </div>
              <div class="col-12 col-md-4">
                <button class="mt-3 primary-button" @click="enviar" :disabled='isDisabled || banLoader'>{{$t('language.posadasCorporate.aclaracionReservaciones.enviar')}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal v-show="isModalVisible" @close="closeModal" maxWidth="max-w-500">
      <template slot="header">
        <b class="verde"> <i class="demo-icon icon-check-fill Fw-bolder"></i> {{$t('language.posadasCorporate.aclaracionReservaciones.titleModal')}}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">{{textModal}}</p>
      </template>
      <template slot="footer">
        <button type="button" class="button btn-primary" @click="closeModal"
          aria-label="Close modal">
          {{$t('language.posadasCorporate.aclaracionReservaciones.entendido')}}
        </button>
      </template>
    </modal>
    <Footer />
  </div>
</template>

<script>
  import * as GlobalServices from '../../../utils/GlobalServices';
  import * as GlobalFunctions from '../../../utils/GlobalFunctions';
  import Header from '../../generales/Header.vue';
  import Footer from '../../generales/Footer.vue';
  import Modal from '../../addons/Modal.vue';
  import SecureLS from 'secure-ls';
  import Loader from '../../loader/Loader';
  import { required, email } from "vuelidate/lib/validators";

  export default {
    name: 'Contacto',
    components: {
      Header,
      Footer,
      Modal,
      Loader
    },
    data() {
      return {
         validRegex: /^[a-zA-Z\\d\\1-9\\0]*$/,
        validRegexEmail: /^[a-zA-Z\\d\\1-9\\0\\.\\_\\@\\-]*$/,
        validRegexUsuario: /^[a-zA-Z\\d\\.]*$/,
        banLoader: false,
        ls: new SecureLS({encodingType: 'aes'}),
        textModal: '',
        isModalVisible: false,
        cliente: '',
        usuario: '',
        correo: '',
        clave: '',
        adicionales: '',
      }
    },
    validations: {
      correo: {
        required,
        email,
      },
    },
    watch: {
    correo() {
        
            let str = "";
            if (!this.validRegexEmail.test(this.correo)) {
              str = this.correo.substring(0, this.correo.length - 1);
              this.correo = str;
            }
      },
      usuario() {
            let str = "";
            if (!this.validRegexUsuario.test(this.usuario)) {
              str = this.usuario.substring(0, this.usuario.length - 1);
              this.usuario = str;
            }
      },
        cliente() {
          let str = "";
            if (!this.validRegex.test(this.cliente)) {
              str = this.cliente.substring(0, this.cliente.length - 1);
              this.cliente = str;
            }
        }
    },
    methods: {
       updateValue(event) {
      const value = event.target.value
      if (String(value).length <= 10) {
        this.clave = value
      }
      this.$forceUpdate()
    },
        isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode === 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
      enviar() {
        this.banLoader = true;
        var data = {
          profileId: this.cliente.toUpperCase(),
          username: this.usuario.toLowerCase(),
          reservationNumber: this.clave,
          email: this.correo,
          commentsAdditional: this.adicionales
        }
        GlobalServices._aclaracionReservacion(this.ls.get('Token').data, this.ls.get('Language').data, data).then(response => {
          if (response.status === 200) {
            this.textModal = response.data.message;
            this.banLoader = false;
            this.isModalVisible = true;
          } else {
            this.$router.push({ name: "Error" });
          }
        }).catch(error => {
          this.banLoader = false;
          if (error.status == 401) {
            this.sesionClose();
          } else{
            this.$router.push({ name: "Error" });
          }
        });
      },
      closeModal() {
        this.isModalVisible = false;
        setTimeout(() => {
          this.$router.push({ name: "InformacionCorporate" });
        }, 200);
      },
      sesionClose(){
        GlobalFunctions.localStorageClean();
        this.$router.push({ name: 'Login'})
      },
      limpiarForm(){
        this.closeModal();
        setTimeout(() => {
          this.cliente = '';
          this.usuario = '';
          this.correo = '';
          this.clave = '';
          this.adicionales = '';
          this.textModal = '';
        }, 350);
      },
    },
    computed: {
      isDisabled() {
        if (this.correo.length > 1 && this.cliente.length >= 2 && this.usuario.length >= 2 && this.clave.length >= 1) {
          if (this.correo.length != '') {
            if (this.correo.length > 6 && this.$v.correo.email) {
              return false;
            } else {
              return true;
            }
          } else {
            return false;
          }
        } else {
          return true;
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../assets/scss/config.scss';

  .minuscula {
  text-transform: lowercase;
}
.mayuscula {
  text-transform: uppercase;
}
  .card-height-custom {
    min-height: 213.67px;
    height: 213.67px;
    .card-body {
      min-height: 213.67px;
      height: 213.67px;
    }
  }
  textarea {
    height: 130px;
  }
</style>